export default __webpack_public_path__ + "static/media/Player_Vastaaja2.55ad0fbb.svg";